<div class="pushpin-selection-container">
    <mat-tab-group (selectedTabChange)="tabChange($event)" mat-stretch-tabs="{{true}}">
        <mat-tab label="Schouwronde">
            <div class="selection">
                @if (customerArea() && !AuthorisationService.hasFeature('inspectionSave')) {
                    <div class="mb-2">
                        <button (click)="chooseInspection.emit()" class="w-100" mat-stroked-button>Selecteer een schouwronde</button>
                    </div>
                }
                @if (customerArea() && AuthorisationService.hasFeature('inspectionSave')) {
                    <div>
                        <app-choose-inspection (inspectionChanged)="inspectionChange()" [customerArea]="customerArea()" [inspection]="inspection()"></app-choose-inspection>
                    </div>
                }
                @if (inspection() && inspection().inspection_status) {
                    <div>
                        <div>
                            <div class="bold">
                                Status: {{inspection().inspection_status.name}}
                            </div>
                            <div class="infotext">
                                @if (inspection()?.inspection_status_id === 1) {
                                    <p>
                                        Sinds: {{inCustomerAreaStatusSince() | date : 'd MMM yyyy H:mm'}} uur<br>
                                        Geschouwde markeringsitems: {{totalParts()}}
                                    </p>
                                }
                                @if (inspection()?.inspection_status_id === 2 && AuthorisationService.hasFeature('selectionToConsumer')) {
                                    <div>
                                        <p>
                                            Geschouwde markeringsitems dienen gecontroleerd te worden voor de klant deze kan
                                            zien.
                                            De klant ziet geen markeringsitems met de status "Concept". Standaard staan punten
                                            die
                                            niet onder "altijd controleren" vallen op "Geschouwd".
                                        </p>
                                        <p>
                                            Vrijgegeven markeringsitems: {{selectedParts()}} van {{totalParts()}}
                                            op {{selectedPushpins()}} locaties.
                                        </p>
                                    </div>
                                }
                                @if (inspection()?.inspection_status_id === 3) {
                                    <div>
                                        <p>
                                            Van Velsen heeft voor {{customerArea().kind}} {{customerArea().name}} {{totalParts()}}
                                            punten geschouwd. U kunt nu selecteren welke punten u wilt laten uitvoeren.
                                            Voor aanpassing van de extra kosten (zoals bijvoorbeeld de verkeersregelaars), kunt
                                            u een hercontrole aanvragen.
                                            Geselecteerde markeringsitems blijven geselecteerd.
                                        </p>
                                        <p>
                                            Selectie afgerond? Ga naar het tabblad 'Status' en kies 'Geselecteerde
                                            markeringsitems in opdracht geven'.
                                        </p>
                                        <p>
                                            Geselecteerde markeringsitems: {{selectedParts()}} van {{totalParts()}}
                                            op {{selectedPushpins()}} locaties.
                                        </p>
                                    </div>
                                }
                                @if (inspection()?.inspection_status_id === 4) {
                                    <div>
                                        <p>
                                            {{customerArea().kind}} {{customerArea().name}} heeft {{selectedParts()}} punten
                                            geselecteerd voor uitvoering. Van Velsen zal deze werkzaamheden gaan inplannen
                                            en uitvoeren als de opdrachtbevestiging binnen is.
                                        </p>
                                        <p>
                                            Geselecteerde markeringsitems: {{selectedParts()}} van {{totalParts()}}
                                            op {{selectedPushpins()}} locaties.
                                        </p>
                                    </div>
                                    <div class="d-flex">
                                    </div>
                                }
                                @if (inspection()?.inspection_status_id === 5) {
                                    <div>
                                        <p>
                                            Van Velsen is de werkzaamheden voor {{customerArea().kind}} {{customerArea().name}}
                                            aan het uitvoeren.
                                            Uitgevoerde markeringsitems: {{selectedParts()}} van {{totalParts()}}
                                            op {{selectedPushpins()}} locaties.
                                        </p>
                                    </div>
                                }
                                @if (inspection()?.inspection_status_id === 6) {
                                    <div>
                                        <p>
                                            Van Velsen heeft de werkzaamheden voor {{customerArea().kind}} {{customerArea().name}}
                                            voltooid! Er zijn {{selectedParts()}} van de {{totalParts()}} vakken uitgevoerd.
                                            U kunt de markeringsitems nu goed- of afkeuren.
                                        </p>
                                        <p>
                                            Uitgevoerde markeringsitems: {{selectedParts()}} van {{totalParts()}}
                                            op {{selectedPushpins()}} locaties.
                                        </p>
                                    </div>
                                }
                            </div>
                        </div>
                        @if (AuthorisationService.hasFeature('selectionPriceForSelectedToggle')) {
                            <div class="pb-2">
                                <mat-slide-toggle
                                    (change)="linkPricesAndFiltersChange()"
                                    [(ngModel)]="linkPriceCalculationToVisibleFilters" color="primary">
                                    Toon prijs voor gefilterde delen
                                </mat-slide-toggle>
                            </div>
                        }
                        @if (materialSurfaces) {
                            <div class="mb-2">
                                <strong class="condensed">
                                    @if (!linkPriceCalculationToVisibleFilters) {
                                        @if (inspection().inspection_status.id === 1) {
                                            Totaal tot nu toe geschouwd
                                        }
                                        @if (inspection().inspection_status.id === 2) {
                                            Selectie voor klant
                                        }
                                        @if (inspection().inspection_status.id > 2) {
                                            Prijsberekening
                                        }
                                    }
                                    @if (linkPriceCalculationToVisibleFilters) {
                                        Totaal gefilterde delen
                                    }
                                </strong>
                                <table class="price-table w-100">
                                    <tr class="border-bottom">
                                        <th>
                                            Item
                                        </th>
                                        <th class="text-right" width="75">
                                            Hoeveelheid
                                        </th>
                                        <th class="text-right" width="80">
                                            Prijs
                                        </th>
                                    </tr>
                                    @if (loadingPrices()) {
                                        <tr>
                                            <td colspan="3">
                                                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                                            </td>
                                        </tr>
                                    }
                                    @for (materialPricesGroup of materialPricesGroups(); track materialPricesGroup.materialIds) {
                                        <tr>
                                            <th colspan="3">
                                                {{materialPricesGroup.group}}
                                            </th>
                                        </tr>
                                        @for (materialPrice of materialPricesGroup.materialPrices; track materialPrice) {
                                            @if (materialSurfaces.get(materialPrice.id) > 0) {
                                                <tr>
                                                    <td>
                                                        <div class="ellipsis">
                                                            {{materialPrice.material.name}}
                                                            {{(materialPrice.paint_color_id < 2) ? '' : materialPrice.paint_color.name}}
                                                        </div>
                                                    </td>
                                                    <td class="price-cell">{{materialSurfaces.get(materialPrice.id) | number:'1.0-2'}}<span class="gray">m
                                                        @if (materialPrice.material_id != 8) {
                                                            <sup>2</sup>
                                                        }
                                                    </span>
                                                    </td>
                                                    <td class="price-cell">
                                                        <span class="eu">€</span> {{materialSurfaces.get(materialPrice.id) * materialPrice.price | number:'1.2-2'}}
                                                    </td>
                                                </tr>
                                            }
                                        }
                                        @for (decorationPrice of materialPricesGroup.specificPriceDecoration; track decorationPrice; let i = $index) {
                                            <tr
                                                [class.no-price]="AuthorisationService.hasFeature('pricesSave') && !decorationPrice.price"
                                                [matTooltipDisabled]="!AuthorisationService.hasFeature('pricesSave') || !!decorationPrice.price"
                                                matTooltip="Er is geen prijs opgegeven voor deze figuratie, er wordt gerekend met de materiaalprijs.">
                                                <td>
                                                    <div class="ellipsis"
                                                         title="{{decorationPrice.decoration.name}}  {{decorationPrice.paint_color_id == 1 ? '' : decorationPrice.paint_color.name}}">
                                                        {{decorationPrice.decoration.name}} {{decorationPrice.paint_color_id == 1 ? '' : decorationPrice.paint_color.name}}
                                                    </div>
                                                </td>
                                                <td class="price-cell">
                                                    {{specificPriceDecorationLength.get(decorationPrice.id) | number:'1.0-2'}}
                                                    <span class="gray">
                                                        {{decorationPrice.decoration.specify_length ? 'm' : decorationPrice.decoration?.surface ? 'st' : 'm2'}}
                                                    </span>
                                                </td>
                                                <td class="price-cell">
                                                    <span class="eu">€</span>
                                                    @if (decorationPrice.price) {
                                                        {{specificPriceDecorationLength.get(decorationPrice.id) * decorationPrice.price | number:'1.2-2'}}
                                                    }
                                                    @if (!decorationPrice.price) {
                                                        {{specificPriceDecorationLength.get(decorationPrice.id) * decorationPrice.overridePrice | number:'1.2-2'}}
                                                    }
                                                </td>
                                            </tr>
                                        }
                                    }
                                    @if (extraCostsList() && extraCostsList().length !== 0) {
                                        <tr class="total">
                                            <th>
                                                Subtotaal:
                                            </th>
                                            <th class="price-cell total" colspan="2">
                                                € {{subTotalPrice() | number:'1.2-2'}}
                                            </th>
                                        </tr>
                                        <tr>
                                            <td colspan="3">&nbsp;</td>
                                        </tr>
                                        <tr class="border-bottom">
                                            <th>
                                                Extra kosten
                                            </th>
                                            <th class="text-right" width="75">
                                                Aantal
                                            </th>
                                            <th class="text-right" width="70">
                                                Prijs
                                            </th>
                                        </tr>
                                        @for (extraCost of extraCostsList(); track extraCost.id) {
                                            <tr
                                                (click)="editExtraCost(extraCost)" [class.curpoint]="AuthorisationService.hasFeature('extraCostSave')"
                                                class="extra-cost-item">
                                                <td>
                                                    <div class="ellipsis" title="{{extraCost.extra_cost_type.name}}">
                                                        {{extraCost.extra_cost_type.name}}
                                                    </div>
                                                </td>
                                                <td class="text-right">
                                                    {{extraCost.number | number :'1.0-2'}} <span
                                                    class="gray"> {{extraCost.extra_cost_type.unit}}</span>
                                                </td>
                                                <td class="price-cell">
                                                    <span class="eu">€</span>
                                                    {{extraCost.number * extraCostsPricesMap[extraCost.extra_cost_type_id] | number:'1.2-2'}}
                                                </td>
                                            </tr>
                                            @if (extraCost.comment) {
                                                <tr
                                                    (click)="editExtraCost(extraCost)"
                                                    [class.curpoint]="AuthorisationService.hasFeature('extraCostSave')" class="extra-cost-item-comment">
                                                    <td colspan="3">
                                                        <i>&nbsp;&nbsp;&nbsp;{{extraCost.comment}}</i>
                                                    </td>
                                                </tr>
                                            }
                                        }
                                    }
                                    @if (tailChargeList() && tailChargeList().length !== 0 && !linkPriceCalculationToVisibleFilters) {
                                        <tr class="total">
                                            <th>
                                                Subtotaal:
                                            </th>
                                            <th class="price-cell total" colspan="2">
                                                € {{subTotalPriceExtraCost() | number:'1.2-2'}}
                                            </th>
                                        </tr>
                                        <tr>
                                            <td colspan="3">&nbsp;</td>
                                        </tr>
                                        <tr class="border-bottom">
                                            <th>
                                                Staartkosten
                                            </th>
                                            <th class="text-right" width="75">
                                                percentage
                                            </th>
                                            <th class="text-right" width="70">
                                                Prijs
                                            </th>
                                        </tr>
                                        @for (tailCharge of tailChargeList(); track tailCharge.id) {
                                            <tr (click)="editTailCharge(tailCharge)" [class.curpoint]="AuthorisationService.hasFeature('saveTailCharges')"
                                                class="extra-cost-item">
                                                <td>
                                                    <div class="ellipsis" title="{{tailCharge.comment}}">
                                                        {{tailCharge.comment}}
                                                    </div>
                                                </td>
                                                <td class="text-right">
                                                    {{tailCharge.number * 100 | number:'1.3-3'}} <span
                                                    class="gray">%</span>
                                                </td>
                                                <td class="price-cell">
                                                    <span class="eu">€</span>
                                                    {{tailCharge.number * subTotalPriceExtraCost() | number:'1.2-2'}}
                                                </td>
                                            </tr>
                                        }
                                    }
                                    <tr class="total">
                                        <th>
                                            Totaal:
                                        </th>
                                        @if (!linkPriceCalculationToVisibleFilters) {
                                            <th class="price-cell total" colspan="2">
                                                € {{totalPrice() | number:'1.2-2'}}
                                            </th>
                                        }
                                        @if (linkPriceCalculationToVisibleFilters) {
                                            <th class="price-cell total" colspan="2">
                                                € {{totalPrice() | number:'1.2-2'}}
                                            </th>
                                        }
                                    </tr>
                                    @if (inspection().inspection_status.selection_allowed && !linkPriceCalculationToVisibleFilters) {
                                        <tr>
                                            <td class="font-italic" colspan="2">
                                                Totaal in schouwronde:
                                            </td>
                                            <td class="font-italic text-right">
                                                <span class="eu">€</span> {{totalPriceAllParts | number:'1.2-2'}}
                                            </td>
                                        </tr>
                                    }
                                </table>
                            </div>
                        }
                        <div>
                            <div class="extra-costs-list">
                                <table class="price-table w-100">
                                </table>
                            </div>
                        </div>
                        @if (AuthorisationService.hasFeature('setPaidState') && inspection()?.inspection_status_id === 7) {
                            <button
                                (click)="setPaid()"
                                class="w-100 mb-1"
                                mat-stroked-button>
                                <i class="fa fa-money-check-alt"></i> Goedgekeurd > betaald ({{partCount}})
                                @if (settingPaid) {
                                    <i class="fa fa-spinner fa-spin"></i>
                                }
                            </button>
                        }
                        @if (AuthorisationService.hasFeature('pricesSave')) {
                            <button
                                [routerLink]="['/prices', {customerAreaIds: customerArea().id,inspectionIds: inspection().id}]"
                                class="w-100 mb-1"
                                mat-stroked-button>
                                <i class="fa fa-euro"></i>
                                Prijzen aanpassen
                            </button>
                        }
                        @if (AuthorisationService.hasFeature('quotationPdf')) {
                            <button
                                (click)="downloadQuotation()"
                                class="w-100 mb-1"
                                mat-stroked-button
                                matTooltip="Punten met de status: {{statusIncludedInPdf.get(inspection()?.inspection_status_id)}}">
                                @if (!generatingQuotation) {
                                    <i class="fa fa-download"></i> Prijsspecificatie downloaden
                                }
                                @if (generatingQuotation) {
                                    <i class="fa fa-spinner fa-spin"></i> Specificatie wordt gemaakt...
                                }
                            </button>
                        }
                        @if (AuthorisationService.hasFeature('quotationPdf') && inspection()?.inspection_status_id > 3 && inspection()?.inspection_type_id === 1) {
                            <button
                                (click)="showChanges()"
                                class="w-100 mb-1"
                                mat-stroked-button>
                                Toon meerwerk t.o.v. offerte
                            </button>
                        }
                        @if (!linkPriceCalculationToVisibleFilters && inspection()?.inspection_type_id === 1) {
                            @if (!inspection().lock && (inspection().inspection_status.selection_allowed || (AuthorisationService.hasFeature('pushpinPartReleaseConsumer') && inspection()?.inspection_status_id === 2))) {
                                <button (click)="addVisiblePoints()" [disabled]="addingPoints || removingPoints" class="w-100 mb-1" color="primary" mat-stroked-button>
                                    @if (addingPoints) {
                                        Items ({{partCount}}) aan het toevoegen <i class="fas fa-circle-notch fa-spin"></i>
                                    }
                                    @if (!addingPoints) {
                                        Items ({{partCount}}) van kaart toevoegen
                                    }
                                </button>
                                <button (click)="removeAllPoints()" [disabled]="addingPoints || removingPoints" class="w-100 mb-1" mat-stroked-button>
                                    @if (removingPoints) {
                                        Selectie aan het wissen... <i class="fas fa-circle-notch fa-spin"></i>
                                    }
                                    @if (!removingPoints) {
                                        Alle punten uit selectie verwijderen
                                    }
                                </button>
                            }
                        }
                    </div>
                }
            </div>
        </mat-tab>
        @if (inspection()) {
            <mat-tab label="Status">
                <div class="actions-container">
                    <div class="selection">
                        @if (customerArea() && AuthorisationService.hasFeature('inspectionSave')) {
                            <div>
                                <app-choose-inspection (inspectionChanged)="inspectionChange()" [customerArea]="customerArea()" [inspection]="inspection()"></app-choose-inspection>
                            </div>
                        }
                    </div>
                    <div class="comments">
                        @if (!inspectionStatusLog()) {
                            <div class="comments-loading">
                                <i class="fas fa-circle-notch fa-spin"></i><br><br>
                                Opmerkingen aan het laden...
                            </div>
                        }
                        @if (inspectionStatusLog()) {
                            <div class="comment-line" id="comment-line">
                                @for (log of inspectionStatusLog(); track log.id) {
                                    <div class="comment-item">
                                        <div class="border-bottom">
                                            <b>{{log.user?.name}}</b>
                                            <div class="date">
                                                {{log.updated_at | date : 'd MMM yyyy, H:mm'}}
                                            </div>
                                        </div>
                                        @if (!log.attachment) {
                                            {{log.comment}}
                                        }
                                        @if (log.attachment) {
                                            <div (click)="downloadAttachment(log)" class="curpoint">
                                                <i class="fas fa-file-alt"></i> {{log.comment}}
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                        }
                        <div class="comment-input">
                            <mat-form-field appearance="fill">
                                <mat-label>Plaats een opmerking</mat-label>
                                <textarea
                                    [(ngModel)]="commentBoxValue"
                                    [disabled]="savingComment"
                                    [maxLength]="500"
                                    matInput>
                                </textarea>
                            </mat-form-field>
                            <div class="comment-actions">
                                <button
                                    (click)="addComment()"
                                    [disabled]="savingComment || !commentBoxValue"
                                    color="primary"
                                    mat-icon-button
                                    matTooltip="Plaats opmerking"
                                    matTooltipPosition="right">
                                    <i class="fas fa-comment"></i>
                                </button>
                                <button
                                    (click)="uploadInput.nativeElement.click()"
                                    [disabled]="uploading"
                                    color="primary"
                                    mat-icon-button
                                    matTooltip="Upload een bestand"
                                    matTooltipPosition="right"
                                    style="padding: 0">
                                    @if (!uploading) {
                                        <i class="fas fa-upload"></i>
                                    }
                                    @if (uploading) {
                                        <i class="fas fa-circle-notch fa-spin"></i>
                                    }
                                    @if (!uploading) {
                                        <input #uploadInput (change)="uploadFile($event)" hidden type="file">
                                    }
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="actions">
                        @if (inspection()?.inspection_status_id === 1 && AuthorisationService.hasFeature('statusFinishInspect')) {
                            <button (click)="statusChange(2)" [disabled]="inspection()?.lock" class="w-100" color="primary" mat-raised-button>
                                <i class="fas fa-check fa-4x pt-2"></i><br>
                                <div class="icon-button-text">
                                    Schouwen afronden
                                </div>
                            </button>
                        }
                        @if (inspection()?.inspection_status_id === 2 && AuthorisationService.hasFeature('statusReleaseInspect')) {
                            <div class="d-flex">
                                <button (click)="statusChange(1)" [disabled]="inspection()?.lock" class="w-100 mb-1 me-1" mat-raised-button>
                                    <i class="fas fa-road fa-4x pt-2"></i><br>
                                    <div class="icon-button-text">
                                        Verder schouwen
                                    </div>
                                </button>
                                <button (click)="statusChange(3)" [disabled]="inspection()?.lock" class="w-100 mb-1 ms-1" color="primary" mat-raised-button>
                                    <i class="fas fa-city fa-4x pt-2"></i><br>
                                    <div class="icon-button-text">
                                        Schouw vrijgeven<br>voor klant
                                    </div>
                                </button>
                            </div>
                        }
                        @if (inspection()?.inspection_status_id === 3) {
                            <div class="d-flex">
                                @if (AuthorisationService.hasAnyFeature(['statusRequestRecontrol', 'statusRecontrol'])) {
                                    <button
                                        (click)="statusChange(2)"
                                        [disabled]="inspection()?.lock"
                                        class="w-100 mb-1 me-1" mat-raised-button>
                                        <i class="fas fa-undo-alt fa-4x pt-2"></i><br>
                                        @if (AuthorisationService.hasFeature('statusRequestRecontrol')) {
                                            <div class="icon-button-text">
                                                Hercontrole <br>aanvragen
                                            </div>
                                        }
                                        @if (AuthorisationService.hasFeature('statusRecontrol')) {
                                            <div class="icon-button-text">
                                                Controle opnieuw <br>starten
                                            </div>
                                        }
                                    </button>
                                }
                                @if (AuthorisationService.hasAnyFeature(['statusGiveOrder', 'statusGiveOrderOverride'])) {
                                    <button
                                        (click)="statusChange(4, true)"
                                        [disabled]="inspection()?.lock"
                                        class="w-100 mb-1 ms-1"
                                        color="primary"
                                        mat-raised-button>
                                        <i class="fas fa-snowplow fa-4x pt-2"></i><br>
                                        <div class="icon-button-text">
                                            Geselecteerde <br>markeringsitems <br> in opdracht geven
                                        </div>
                                    </button>
                                }
                            </div>
                        }
                        @if (inspection()?.inspection_status_id === 4) {
                            <div class="d-flex">
                                @if (AuthorisationService.hasFeature('statusRestartInspect')) {
                                    <button
                                        (click)="statusChange(1)" [disabled]="inspection()?.lock"
                                        class="w-100 me-1 mb-1"
                                        mat-raised-button>
                                        <i class="fas fa-undo-alt fa-4x pt-2"></i><br>
                                        <div class="icon-button-text">
                                            Schouw opnieuw <br>starten
                                        </div>
                                    </button>
                                }
                                @if (AuthorisationService.hasFeature('statusStartExecution')) {
                                    <button
                                        (click)="statusChange(5)" [disabled]="inspection()?.lock"
                                        class="w-100 mb-1 ms-1"
                                        color="primary"
                                        mat-raised-button>
                                        <img src="./assets/images/j16_white.svg" style="max-width: 56px;"><br>
                                        <div class="icon-button-text">
                                            Uitvoering starten
                                        </div>
                                    </button>
                                }
                            </div>
                        }
                        @if (inspection()?.inspection_status_id === 5) {
                            @if (AuthorisationService.hasFeature('statusFinishExecution')) {
                                <button
                                    (click)="statusChange(6)"
                                    [disabled]="inspection()?.lock"
                                    class="w-100 mb-1"
                                    color="primary"
                                    mat-raised-button>
                                    <i class="fas fa-check fa-4x pt-2"></i><br>
                                    <div class="icon-button-text">
                                        Uitvoering afronden
                                    </div>
                                </button>
                            }
                        }
                        @if (inspection()?.inspection_status_id === 6) {
                            <div class="d-flex">
                                @if (AuthorisationService.hasFeature('statusBackToExecution')) {
                                    <button
                                        (click)="statusChange(5)"
                                        [disabled]="inspection()?.lock"
                                        class="w-100 mb-1 me-1"
                                        mat-raised-button>
                                        <i class="fas fa-undo-alt fa-4x pt-2"></i><br>
                                        <div class="icon-button-text">
                                            Terug naar <br>'In uitvoering'
                                        </div>
                                    </button>
                                }
                                @if (AuthorisationService.hasFeature('statusExecutionReady')) {
                                    <button
                                        (click)="statusChange(7)"
                                        [disabled]="inspection()?.lock"
                                        class="w-100 mb-1 ms-1"
                                        color="primary"
                                        mat-raised-button>
                                        <i class="fas fa-check fa-4x pt-2"></i><br>
                                        <div class="icon-button-text">
                                            Klaar met <br>uitvoering
                                        </div>
                                    </button>
                                }
                            </div>
                        }
                        @if (inspection()?.inspection_status_id === 7) {
                            <div class="d-flex">
                                @if (AuthorisationService.hasFeature('statusStartNewInspect')) {
                                    <button
                                        (click)="statusChange(1)"
                                        [disabled]="inspection()?.lock"
                                        class="w-100 mb-1 ms-1"
                                        color="primary"
                                        mat-raised-button>
                                        <i class="fas fa-road fa-4x pt-2"></i><br>
                                        <div class="icon-button-text">
                                            Nieuwe schouw<br>starten
                                        </div>
                                    </button>
                                }
                                @if (AuthorisationService.hasFeature('statusStartNewInspect')) {
                                    <button
                                        (click)="acceptWork()"
                                        [disabled]="inspection()?.lock"
                                        class="w-100 mb-1 ms-1"
                                        color="primary"
                                        mat-raised-button>
                                        <i class="fas fa-check fa-4x pt-2"></i><br>
                                        <div class="icon-button-text">
                                            Uitgevoerd werk<br>goedkeuren
                                        </div>
                                    </button>
                                }
                            </div>
                        }
                    </div>
                </div>
            </mat-tab>
        }
    </mat-tab-group>
</div>
